import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AppService, ValueIdPair } from 'src/app/_services/app.service';

@Component({
    selector: 'app-spreadsheets',
    templateUrl: './spreadsheets.component.html',
    standalone: false
})
export class SpreadsheetsComponent implements OnInit {


  spreadsheets: SpreadsheetsOutput;
  isLoading: boolean = false;


  constructor(@Inject('BASE_URL') private baseUrl: string, private http: HttpClient, public service: AppService) { 
    this.service.SetTranslation('my-general-markets/spreadsheets');
  }

  ngOnInit() {
    this.InitializeValues();
    this.GetSpreadsheets();
  }

  /** Gets all the spreadsheets */
  GetSpreadsheets() {
    this.isLoading = true;
    this.http.get<SpreadsheetsOutput>(this.baseUrl + 'api/spreadsheets/getSpreadsheets').subscribe(result => {
      this.spreadsheets = result;
      this.isLoading = false;
    }, error => {
      console.error(error);
    });
  }

  /** Initializes the spreadsheet values */
  InitializeValues() {
    this.spreadsheets = {
      marketContributions: null,
      marketRates: null
    };
  }

  /** Click event for the spreadsheet item */
  OnClickSpreadsheet(spreadsheet: ValueIdPair) {
    this.service.showSpinner();
    this.http.post(this.baseUrl + 'api/spreadsheets/getSpreadsheet', spreadsheet, {responseType: 'blob'}).subscribe(result => {
      
      if (result) {
        const url = window.URL.createObjectURL(result);
        const anchor = document.createElement('a');
        anchor.download = spreadsheet.id + '.xlsx';
        anchor.href = url;
        anchor.click();
        // window.open(url);
        document.removeChild(anchor);
      } else {
        //this.service.SaveStatus(false, 'Spreadsheets.header', result.value);
      }
    }, error => {
      console.error(error);
    }, () => {
      this.service.hideSpinner();
    });

  }
}

/** Interface for the spreadsheets section for a market */
interface Spreadsheet {
  marketName: string;
  availableSpreadsheets: ValueIdPair[];
}

/** Interface for map the server response */
interface SpreadsheetsOutput {
  marketRates: Spreadsheet[];
  marketContributions: Spreadsheet[]
}